import { FeatureFlags } from '../constants/FeatureFlags';
import { usePublicFeatureFlags } from './usePublicFeatureFlags';
export function useIsHubSpotOnCredits() {
  const {
    featureFlags,
    loading
  } = usePublicFeatureFlags();
  return {
    isHubSpotOnCredits: featureFlags.includes(FeatureFlags.HUBSPOT_ON_CREDITS),
    loading
  };
}